import React, { useEffect, useState, useCallback } from 'react';
import { BasicTableRow, getBasicTableData, Pagination } from 'api/clinicsGet.api';
import { BaseTable } from '@app/components/common/BaseTable/BaseTable';
import { ColumnsType } from 'antd/es/table';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useTranslation } from 'react-i18next';
import { defineColorByPriority } from '@app/utils/utils';
import { notificationController } from 'controllers/notificationController';
import { Status } from '@app/components/profile/profileCard/profileFormNav/nav/payments/paymentHistory/Status/Status';
import { useMounted } from '@app/hooks/useMounted';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseSpace } from '@app/components/common/BaseSpace/BaseSpace';
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { getAllCategoriesAction } from '@app/store/slices/userSlice';
const initialPagination: Pagination = {
  current: 1,
  pageSize: 20,
};

export const BasicTable: React.FC = () => {
  const [tableData, setTableData] = useState<{ data: BasicTableRow[]; pagination: Pagination; loading: boolean }>({
    data: [],
    pagination: initialPagination,
    loading: false,
  });
  const { t } = useTranslation();
  const { isMounted } = useMounted();
  let navigate = useNavigate();


  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAllCategoriesAction())
      .unwrap()
      .then((resp) => {

        setTableData({ ...tableData, data: resp.data });

      }).catch((err) => {
        notificationController.error({ message: err.message });
      })

  }, []);

  const fetch = useCallback(
    (pagination: Pagination) => {
      setTableData((tableData) => ({ ...tableData, loading: true }));
      // getBasicTableData(pagination).then((res) => {
      //   if (isMounted.current) {
      //     setTableData({ data: res.data, pagination: res.pagination, loading: false });
      //   }
      // });
    },
    [isMounted],
  );

  useEffect(() => {
    fetch(initialPagination);
  }, [fetch]);

  const handleTableChange = (pagination: Pagination) => {
    fetch(pagination);
  };

  const handleDeleteRow = (rowId: number) => {
    setTableData({
      ...tableData,
      data: tableData.data.filter((item) => item.key !== rowId),
      pagination: {
        ...tableData.pagination,
        total: tableData.pagination.total ? tableData.pagination.total - 1 : tableData.pagination.total,
      },
    });
  };

  const columns: ColumnsType<BasicTableRow> = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (text: string) => <span>{text}</span>,

    },

    {
      title: t('common.status'),
      key: 'isActive',
      dataIndex: 'isActive',
      render: (isActive: Boolean) => (
        <BaseRow gutter={[10, 10]}>


          <BaseCol>
            <Status color={isActive ? 'var(--success-color)' : 'var(--error-color)'} text={isActive ? 'ACTIVE' : 'INACTIVE'} />
          </BaseCol>


        </BaseRow>
      ),
    },
    {
      title: t('tables.actions'),
      dataIndex: 'actions',
      width: '15%',
      render: (text: string, record: any) => {
        return (
          <BaseSpace>
            <BaseButton
              type="ghost"
              onClick={() => {
                navigate('/admin/categories/edit/' + record?._id)
                // notificationController.info({ message: t('tables.inviteMessage', { name: record.name }) });
              }}
            >
              {t('common.edit')}
            </BaseButton>

            {/* <BaseButton
              type="ghost"
              onClick={() => {
                navigate('/admin/clinics/patients/list')
                // notificationController.info({ message: t('tables.inviteMessage', { name: record.name }) });
              }}
            >
              Patients
            </BaseButton>


            <BaseButton type="default" danger>
              {t('common.markInactive')}
            </BaseButton> */}
          </BaseSpace>
        );
      },
    },
  ];

  return (
    <BaseTable
      columns={columns}
      dataSource={tableData.data}
      pagination={tableData.pagination}
      loading={tableData.loading}
      onChange={handleTableChange}
      scroll={{ x: 800 }}
      bordered
    />
  );
};
